import airtableLogo from "../../assets/images/brand/airtable-logo.png";
import firestoreLogo from "../../assets/images/brand/firestore-logo.png";
import notionLogo from "../../assets/images/brand/notion-logo.png";
import mongodbLogo from "../../assets/images/brand/mongodb-logo.png";
import postgresqlLogo from "../../assets/images/brand/postgresql-logo.png";
import mssqlLogo from "../../assets/images/brand/mssql-logo.png";
import defaultdbLogo from "../../assets/images/default/default-db.png";

export default {
  airtableLogo: airtableLogo,
  firestoreLogo: firestoreLogo,
  notionLogo: notionLogo,
  mongodbLogo: mongodbLogo,
  postgresqlLogo: postgresqlLogo,
  mssqlLogo: mssqlLogo,
  defaultdbLogo: defaultdbLogo,
}